import React, { useState } from 'react';
import cx from 'classnames';
import _noop from 'lodash/noop';
import { useMediaQuery } from '@mui/material';
import { makeStyles } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

import * as appConstants from 'constants/app';

import * as ROUTES from 'constants/routes';

import styles from './index.module.scss';

function Sidebar({ role, onSignOut, onClick}) {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    
    const useStyles = makeStyles((theme) => ({
        root: {
            '& .MuiSvgIcon-root': {
                width: matches ? '24px' : '16px'
            }
        }
    }));
    
    const [activeMenu, setactiveMenu] = useState(null);  
    
    const toggleMenu = (menuId) => {
        setactiveMenu(activeMenu==menuId?'':menuId);
    };
    let showAdminMenu =false;
    if(role=='admin'){
        showAdminMenu =true
    }
    if(role=='gmanager'){
        showAdminMenu =true
    }
    const classes = useStyles();
    return (
        <div className={styles.wrapper}>
           
            
            <ul>
                <li key={'menu_1'} className={(activeMenu=='WebappManagement'?styles.active:'')}>
                    <p
                    className={cx(styles.navItem, styles.dropdown)}
                    onClick={() => {toggleMenu('WebappManagement')}}
                    >Webapp Management</p>
                    {appConstants[role + 'SidebarRoutes'].map((route) => (
                   <>
                    {appConstants.sidebar[route] && (
                        <>
                        {appConstants.sidebar[route].parent == 'WebappManagement' &&<NavLink
                               exact
                               to={ROUTES[route]}
                               className={cx(styles.navItem, classes.root)}
                               activeClassName={styles.active}
                           >
                               <p className={styles.name} onClick={onClick ? onClick : _noop}>
                                   {appConstants.sidebar[route].name}
                               </p>
                               
                           </NavLink>}
                        </>
                    )}
                </>
            ))}
                </li>

                <li key={'menu_2'} className={(activeMenu=='WalletManagement'?styles.active:'')}>
                <p
                    className={cx(styles.navItem, styles.dropdown)}
                    onClick={() => {toggleMenu('WalletManagement')}}
                    >
                        Wallet Management</p>
                    {appConstants[role + 'SidebarRoutes'].map((route) => (
                   <>
                    {appConstants.sidebar[route] && (
                        <>
                        {appConstants.sidebar[route].parent == 'WalletManagement' &&<NavLink
                               exact
                               to={ROUTES[route]}
                               className={cx(styles.navItem, classes.root)}
                               activeClassName={styles.active}
                           >
                               <p className={styles.name} onClick={onClick ? onClick : _noop}>
                                   {appConstants.sidebar[route].name}
                               </p>
                               
                           </NavLink>}
                        </>
                    )}
                </>
            ))}
                </li>

                {showAdminMenu &&<li key={'menu_3'}  className={(activeMenu=='TeamManagement'?styles.active:'')}>
                <p
                    className={cx(styles.navItem, styles.dropdown)}
                    onClick={() => {toggleMenu('TeamManagement')}}
                    >
                    Team Management</p>
                    {appConstants[role + 'SidebarRoutes'].map((route) => (
                   <>
                    {appConstants.sidebar[route] && (
                        <>
                        {appConstants.sidebar[route].parent == 'TeamManagement' &&<NavLink
                               exact
                               to={ROUTES[route]}
                               className={cx(styles.navItem, classes.root)}
                               activeClassName={styles.active}
                           >
                               <p className={styles.name} onClick={onClick ? onClick : _noop}>
                                   {appConstants.sidebar[route].name}
                               </p>
                               
                           </NavLink>}
                        </>
                    )}
                </>
            ))}
                </li>}

                {showAdminMenu &&<li key={'menu_4'} className={(activeMenu=='GCManagement'?styles.active:'')}>
                <p
                    className={cx(styles.navItem, styles.dropdown)}
                    onClick={() => {toggleMenu('GCManagement')}}
                    >GC Management</p>
                    {appConstants[role + 'SidebarRoutes'].map((route) => (
                   <>
                    {appConstants.sidebar[route] && (
                        <>
                        {appConstants.sidebar[route].parent == 'GCManagement' &&<NavLink
                               exact
                               to={ROUTES[route]}
                               className={cx(styles.navItem, classes.root)}
                               activeClassName={styles.active}
                           >
                               <p className={styles.name} onClick={onClick ? onClick : _noop}>
                                   {appConstants.sidebar[route].name}
                               </p>
                               
                           </NavLink>}
                        </>
                    )}
                </>
            ))}
                </li>}

                {showAdminMenu &&<li key={'menu_5'} className={(activeMenu=='InstaManagement'?styles.active:'')}>
                <p
                    className={cx(styles.navItem, styles.dropdown)}
                    onClick={() => {toggleMenu('InstaManagement')}}
                    >Insta Management</p>
                    {appConstants[role + 'SidebarRoutes'].map((route) => (
                   <>
                    {appConstants.sidebar[route] && (
                        <>
                        {appConstants.sidebar[route].parent == 'InstaManagement' &&<NavLink
                               exact
                               to={ROUTES[route]}
                               className={cx(styles.navItem, classes.root)}
                               activeClassName={styles.active}
                           >
                               <p className={styles.name} onClick={onClick ? onClick : _noop}>
                                   {appConstants.sidebar[route].name}
                               </p>
                               
                           </NavLink>}
                        </>
                    )}
                </>
            ))}
                </li>}

                    {appConstants[role + 'SidebarRoutes'].map((route,index) => (
                    <div key={'route_'+index}>
                    {appConstants.sidebar[route] && (
                        <>
                        {appConstants.sidebar[route].parent == 'other' &&<>
                        {appConstants.sidebar[route].name == 'Fintech' ? (
                                <a
                                    className={styles.navItem}
                                    activeClassName={styles.active}
                                    target="_blank"
                                    href="https://teamsales.info/?hash=8ore7hMR8m1vq1agUcUaXfEnvGOvS%2BEOIYuDNlOEvrY%3D"
                                >
                                    <p className={styles.name} onClick={onClick ? onClick : _noop}>
                                        Fintech Products
                                    </p>
                                </a>
                            ) : (
                                <NavLink
                                    exact
                                    to={ROUTES[route]}
                                    className={cx(styles.navItem, classes.root)}
                                    activeClassName={styles.active}
                                >
                                    <p className={styles.name} 
                                    onClick={onClick ? onClick : _noop}
                                    >
                                        {appConstants.sidebar[route].name}
                                    </p>
                                </NavLink>
                            )}
                        </>}
                        </>
                    )}
                    </div>
            ))}
            </ul>
             
        </div>
    );
}

export default Sidebar;
